import React from 'react';
import styled from 'styled-components';
import {
  Box,
  StarRating,
  Icon,
  useTheme,
  Grid,
  Text,
  IconName,
  Tooltip,
} from '@wegroup/design-system';
import { mq } from '../../../../common/src/utils/styledComponentsUtils';
import { QuoteCoverageGroup } from '../../../../../types/Quotes';

interface Props {
  coverages: QuoteCoverageGroup[];
  onlyIcons?: boolean;
}

const OfferCoveragesContainer: React.FC<React.PropsWithChildren<Props>> = ({
  coverages,
  onlyIcons,
}) => {
  const { colors } = useTheme();

  return onlyIcons ? (
    <OnlyIconContainer gap="2" templateColumns="repeat(auto-fill, 24px)">
      {coverages.map(({ icon_key, name }, i) => (
        <Tooltip label={<Text textStyle="smallbody">{name}</Text>} key={i}>
          <Box>
            <Icon name={icon_key as IconName} color={colors.primary[500]} />
          </Box>
        </Tooltip>
      ))}
    </OnlyIconContainer>
  ) : (
    <Wrapper>
      {coverages.map(({ key, icon_key, name, rating }, i) => (
        <Coverage key={`coverage_${key}`}>
          <IconContainer>
            <Icon
              key={i}
              name={icon_key as IconName}
              color={colors.primary[500]}
            />
          </IconContainer>
          <div>
            <Text>{name}</Text>
            <StarRating starCount={rating || 0} color={colors.primary[500]} />
          </div>
        </Coverage>
      ))}
    </Wrapper>
  );
};

const OnlyIconContainer = styled(Grid)`
  > svg {
    width: 2.4rem;
    height: 2.4rem;
  }
`;

const IconContainer = styled.div`
  width: 2rem;
  height: 2rem;
  background-color: ${({ theme }) => theme.primary[50]};
  border-radius: 50px;
  align-items: center;
  justify-content: center;
  display: none;

  ${mq.laptop} {
    display: flex;
  }

  > svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const Coverage = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.8rem;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 1.6rem;
  margin-top: 1.6rem;
`;

export default OfferCoveragesContainer;
